<template>
  <section class="yellow-light-green flex flex-col items-center justify-center py-16">
    <UiStripesArticles
      class="yellow-light-green"
      :show-all="false"
      :range="[3, 6]"
    />
    <UiStripesArticles
      class="yellow-light-green"
      :show-all="false"
      :range="[6, 8]"
    />
    <UiStripesArticles
      class="yellow-light-green"
      :show-all="true"
      :range="[8, 12]"
    />
  </section>
</template>
